import type { Plugin } from 'vue'

const portalNames = {
  authTeleportHost: 'auth-teleport-host'
}

const PortalPlugin: Plugin = {
  install: (app) => {
    app.config.globalProperties.$portalNames = portalNames
  }
}

export {
  portalNames,
  PortalPlugin
}
